/* Seyasha: at most 2 pieces of each product in the cart (all sizes together).
   Checks every add and quantity change the theme makes, and trims the cart if it ever goes over. */
(function () {
  var MAX = 2;
  var MSG = 'You can add up to ' + MAX + ' pieces of each design.';
  if (!window.fetch || window.__syLimit) return;
  window.__syLimit = true;
  var realFetch = window.fetch.bind(window);

  function urlOf(input) { return typeof input === 'string' ? input : (input && input.url) || ''; }
  function isAdd(u) { return /\/cart\/add(\.js)?(\?|$)/.test(u); }
  function isChange(u) { return /\/cart\/change(\.js)?(\?|$)/.test(u); }
  function isUpdate(u) { return /\/cart\/update(\.js)?(\?|$)/.test(u); }
  function getCart() {
    return realFetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function totals(cart) {
    var t = {};
    cart.items.forEach(function (i) { t[i.product_id] = (t[i.product_id] || 0) + i.quantity; });
    return t;
  }
  function productOfVariant(vid, cart) {
    vid = String(vid);
    for (var i = 0; i < cart.items.length; i++) if (String(cart.items[i].variant_id) === vid) return cart.items[i].product_id;
    var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    if (meta && meta.variants) for (var j = 0; j < meta.variants.length; j++) if (String(meta.variants[j].id) === vid) return meta.id;
    /* quick add on product cards (collection pages, homepage rails): the card carries the product id */
    var btn = document.querySelector('[data-sy-qa-variant="' + vid.replace(/[^0-9]/g, '') + '"]');
    var card = btn && btn.closest('[data-sy-id]');
    if (card) return +card.getAttribute('data-sy-id');
    return null;
  }
  function toast(text) {
    var el = document.getElementById('sy-limit-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'sy-limit-toast';
      el.setAttribute('role', 'status');
      el.style.cssText = 'position:fixed;left:50%;bottom:2.4rem;transform:translateX(-50%);z-index:2147483000;max-width:calc(100% - 3.2rem);padding:1.2rem 1.8rem;border-radius:1.2rem;background:#121212;color:#fff;font-size:1.4rem;line-height:1.4;box-shadow:0 1.2rem 3rem -1rem rgba(0,0,0,.4);transition:opacity .3s';
      document.body.appendChild(el);
    }
    el.textContent = text;
    el.style.opacity = '1';
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.style.opacity = '0'; }, 3500);
  }
  function refused() {
    toast(MSG);
    return new Response(JSON.stringify({ status: 422, message: 'Cart Error', description: MSG }), { status: 422, headers: { 'Content-Type': 'application/json' } });
  }
  /* read {id, quantity} pairs from an add request body */
  function addItems(body) {
    var out = [];
    if (!body) return out;
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      if (body.get('id')) out.push({ id: body.get('id'), quantity: parseInt(body.get('quantity') || '1', 10) });
      return out;
    }
    if (typeof body === 'string') {
      try {
        var j = JSON.parse(body);
        if (j.items) j.items.forEach(function (i) { out.push({ id: i.id, quantity: parseInt(i.quantity || 1, 10) }); });
        else if (j.id) out.push({ id: j.id, quantity: parseInt(j.quantity || 1, 10) });
      } catch (e) {
        var p = new URLSearchParams(body);
        if (p.get('id')) out.push({ id: p.get('id'), quantity: parseInt(p.get('quantity') || '1', 10) });
      }
    }
    return out;
  }
  /* if the cart is over the limit (e.g. an add we could not check first), trim the newest lines */
  function enforce() {
    return getCart().then(function (cart) {
      var t = totals(cart), updates = {}, changed = false;
      Object.keys(t).forEach(function (pid) {
        var over = t[pid] - MAX;
        if (over <= 0) return;
        cart.items.forEach(function (i) {
          if (over <= 0 || String(i.product_id) !== pid) return;
          var cut = Math.min(over, i.quantity);
          updates[i.key] = i.quantity - cut;
          over -= cut;
          changed = true;
        });
      });
      if (!changed) return false;
      return realFetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates })
      }).then(function () { toast(MSG); setTimeout(function () { location.reload(); }, 1200); return true; });
    }).catch(function () { return false; });
  }

  window.fetch = function (input, init) {
    var u = urlOf(input);
    var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    if (method !== 'POST' || !(isAdd(u) || isChange(u))) {
      var res = realFetch(input, init);
      if (method === 'POST' && isUpdate(u)) res.then(function () { enforce(); });
      return res;
    }
    return getCart().then(function (cart) {
      var t = totals(cart);
      if (isAdd(u)) {
        var items = addItems(init && init.body), unknown = false;
        for (var k = 0; k < items.length; k++) {
          var pid = productOfVariant(items[k].id, cart);
          if (pid == null) { unknown = true; continue; }
          if ((t[pid] || 0) + items[k].quantity > MAX) return refused();
          t[pid] = (t[pid] || 0) + items[k].quantity;
        }
        var r = realFetch(input, init);
        if (unknown) r.then(function () { enforce(); });
        return r;
      }
      /* change: {line or id or key, quantity} */
      var b = {};
      try { b = JSON.parse((init && init.body) || '{}'); } catch (e) { return realFetch(input, init); }
      var item = null;
      if (b.line) item = cart.items[parseInt(b.line, 10) - 1];
      else if (b.id) item = cart.items.filter(function (i) { return String(i.key) === String(b.id) || String(i.variant_id) === String(b.id); })[0];
      if (!item || b.quantity == null) return realFetch(input, init);
      var others = (t[item.product_id] || 0) - item.quantity;
      var allowed = Math.max(0, MAX - others);
      if (parseInt(b.quantity, 10) > allowed) {
        b.quantity = allowed;
        toast(MSG);
        init = Object.assign({}, init, { body: JSON.stringify(b) });
      }
      return realFetch(input, init);
    }).catch(function () { return realFetch(input, init); });
  };

  /* cart page and drawer: cap the number boxes so the browser and the + button stop at the limit */
  function capInputs(root) {
    (root || document).querySelectorAll('input[name="updates[]"], .quantity__input').forEach(function (inp) {
      if (!inp.max || parseInt(inp.max, 10) > MAX) inp.max = MAX;
    });
  }
  document.addEventListener('DOMContentLoaded', function () {
    capInputs();
    new MutationObserver(function () { capInputs(); }).observe(document.body, { childList: true, subtree: true });
    if (/\/cart(\/|$|\?)/.test(location.pathname)) enforce();
  });
  /* a cart form posted straight to the server (checkout button) */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.querySelectorAll) return;
    f.querySelectorAll('input[name="updates[]"]').forEach(function (inp) { if (parseInt(inp.value, 10) > MAX) inp.value = MAX; });
  }, true);
})();